import { OnInit } from '@angular/core';
import { SupportedBrowsersService } from './supported-browsers.service';
var SupportedBrowsersModalComponent = /** @class */ (function () {
    function SupportedBrowsersModalComponent(supportedBrowsersService) {
        this.supportedBrowsersService = supportedBrowsersService;
        this.shouldDisplay = false;
    }
    SupportedBrowsersModalComponent.prototype.ngOnInit = function () {
        this.shouldDisplay = this.supportedBrowsersService.shouldDisplayModal();
    };
    SupportedBrowsersModalComponent.prototype.openChromeDownloadPage = function () {
        this.supportedBrowsersService.openChromeDownloadPage();
    };
    SupportedBrowsersModalComponent.prototype.continue = function () {
        this.supportedBrowsersService.setModalHaveBeenShown();
        this.shouldDisplay = false;
    };
    return SupportedBrowsersModalComponent;
}());
export { SupportedBrowsersModalComponent };
